import { observable, action, runInAction } from 'mobx';
import { StaticLookupUrls } from '../domain/entities/Config';
import * as jp from 'jsonpath';
import { RampPgApiSdk } from '../../api/RampPgApiSdk';
import { diContainer, serviceNames } from '../../service-setup/diContainer';

// Might contain additional properties, like postal code for a district option
export interface ICascadingDropdownOption {
    value: string;
    label: string;
    jpPath: string;
    subtree?: ICascadingDropdownOption[];
    // TODO: APACFTRS1-770 is it possible to exclude ICascadingDropdownOption[]?
    [key: string]: string | ICascadingDropdownOption[] | undefined;
}

// TODO: APACFTRS1-770 rename to repository and better not pass functions via context
export class DropdownDataStore {
    private api: RampPgApiSdk;

    constructor() {
        this.api = diContainer.get(serviceNames.rampPgApiSdk);
    }

    // Stores all JSON data get from staticLookupUrls.
    @observable public staticLookupJsonCollection: Map<
        string,
        ICascadingDropdownOption[]
    > = new Map();

    @observable public currentPaths: Map<string, string> = new Map();

    public loadDropdownData = async (staticLookupUrls?: StaticLookupUrls) => {
        if (staticLookupUrls) {
            for (const name of Object.keys(staticLookupUrls)) {
                const dropDownData = await this.api.loadStaticJsonContent(staticLookupUrls[name]);

                runInAction(() => {
                    this.staticLookupJsonCollection.set(name, dropDownData);
                });
            }
        }
    };

    public getStaticOptions = (
        staticLookupName: string,
        hasParent: boolean,
        parentPathKey: string | undefined
    ): ICascadingDropdownOption[] => {
        const parentPath = parentPathKey ? this.currentPaths.get(parentPathKey) : undefined;
        if (hasParent && !parentPath) {
            return [];
        }
        const json = this.staticLookupJsonCollection.get(staticLookupName) || [];

        const path = parentPath ? `${parentPath}.subtree.*` : '$.*';

        return jp.nodes(json, path).map((node) => {
            const { path: jpPath, value: item } = node;

            return {
                ...item,
                label: item.label || item.value,
                jpPath: jp.stringify(jpPath)
            };
        });
    };

    @action
    public setCurrentPath = (staticLookupName: string, fieldName: string, jpPath: string) => {
        this.currentPaths.set(`${staticLookupName}/${fieldName}`, jpPath);
    };
}
